<template>
    <div id="about_mtn">
        <div>
            <div class="social-nav filter-blur-50 border-bottom-white-1-50">
                <!-- Keep the nameContainer with home and arrow icons -->
                <div class="nameContainer">
                    <router-link to="/personal" class="d-flex">
                        <div class="homeIcon">
                            <a><img src="../../assets/icons/homeIcon.svg" height="20px" width="20px"></a>
                        </div>
                    </router-link>
                    <div class="arrowIcon">
                        <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
                    </div>
                    <div class="titleName">{{ info.title }}</div>
                </div>

                <!-- Tabs container with exact 37.28px padding -->
                <div class="tabsContainer">
                    <v-tabs v-model="tab" grow centered show-arrows class="social-tab">
                        <v-tabs-slider color="#FFCB05"></v-tabs-slider>
                        <v-tab v-for="item in info.items" :key="item.title">
                            {{ item.title }}
                        </v-tab>
                    </v-tabs>
                </div>
            </div>

            <v-tabs-items v-model="tab" :touchless="true">
                <v-tab-item v-for="item in info.items" :key="item.title">
                    <component :is="item.comp" />
                </v-tab-item>
            </v-tabs-items>
        </div>
    </div>
</template>
  
<script>
import WhoWeAre from '../AboutMtn/WhoWeAre'
import SocialResponsibility from '../AboutMtn/SocialResponsibility'
import FinancialReports from '../AboutMtn/FinancialReports'
import utils from '../../shared/utils'
import $ from 'jquery'
import Navbar from '../Navbar'

export default {
    name: 'AboutMtn',
    components: { Navbar, WhoWeAre, SocialResponsibility, FinancialReports },
    data() {
        return {
            tab: null,
            info: {
                title: this.$t('whoWeAre.About'),
                items: [
                    { title: this.$t('TabsBar.WhoWeAre'), comp: 'WhoWeAre', path: 'who-we-are' },
                    { title: this.$t('TabsBar.SocialResponsibility'), comp: 'SocialResponsibility', path: 'social-responsibility' },
                    { title: this.$t('TabsBar.FinancialReports'), comp: 'FinancialReports', path: 'financial-reports' }
                ]
            },
            activeTab: ''
        }
    },
    created() {
        this.activeTab = this.$route.params.id
        this.$store.state.activeSectionNav = null
    },
    mounted() {
        this.arabic()
        this.tab = utils.checkActiveTab(this.info.items, this.activeTab)
    },
    methods: {
        arabic() {
            if (this.$lang === 'ar') {
                $('.social-nav').css('direction', 'rtl')
                $('.arrowIcon').css('transform', 'rotateY(180deg)')
                $('.tabsContainer').addClass('arabicTabContainer')
                $('.social-tab .v-tab').css('transform', 'rotateY(180deg)')
                $('.social-tab .v-tab').css('padding', '0 3vw')
            }
        }
    },
    watch: {
        tab(val) {
            this.$store.state.tab = val
            window.scrollTo(0, 0)
            $('#press_releases .tabsContainer').addClass('arabicTabContainer')
            $('#press_releases .innerTabContainer .v-tab').css('transform', 'rotateY(180deg)')
        },
        '$route.params.id': {
            handler: function (id) {
                this.tab = utils.checkActiveTab(this.info.items, id)
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
  
<style lang="scss">
@import "src/assets/sass/main";

/* Main container with exact 930px width and 50px height */
.tabsContainer {
    width: 930px;
    /* Exact width */
    height: 50px;
    /* Exact height */
    padding: 0 37.28px;
    /* Exact horizontal padding */
    box-sizing: border-box;
}

/* Main navigation bar */
.social-nav {
    height: 50px;
    /* Exact height */
    background: rgba(242, 242, 242, 1);
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
    margin: 0px;
    display: flex;
    position: fixed;
    z-index: 210;
    top: 110px;
    width: 100%;
    justify-content: center;
    /* Center the tabs container */
}

/* Center the tabs within the 930px container */
.social-nav .v-tabs {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

/* Individual tab styling */
.social-tab .v-tab {
    padding: 0 37.28px !important;
    /* Exact horizontal padding for tabs */
    font-size: 14px !important;
    text-transform: capitalize;
    height: 50px;
    /* Match container height */
    min-width: 150px;
    /* Ensure tabs have enough width */
    font-family: Mtn-bold;
    box-sizing: border-box;
}

/* Active tab styling */
.social-tab .v-tab--active {
    color: $--yellow !important;
    font-family: Mtn-bold;
    font-size: 14px !important;
    background-color: rgba(255, 203, 5, 0.1);
    border-bottom: 3px solid $--yellow;
}

/* Inactive tab styling */
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active) {
    color: rgba(29, 29, 29, 0.8) !important;
    font-weight: normal;
}

/* Slider styling */
.v-tabs-slider {
    height: 3px !important;
}

/* NameContainer adjustments */
.nameContainer {
    display: flex;
    padding: 0 30px 0 40px;
    align-items: center;
    min-width: 200px;
    position: absolute;
    left: 0;
    height: 50px;
}

.homeIcon {
    cursor: pointer;
    display: flex;
    align-items: center;
}

.homeIcon,
.arrowIcon,
.titleName {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
}

.titleName {
    width: max-content;
    color: $--yellow;
    font-family: Mtn-bold;
    text-decoration: underline;
    font-size: 14px;
}

/* Remove the tabs bar background */
.theme--light.v-tabs>.v-tabs-bar {
    background: transparent !important;
}

/* Responsive design */
@media only screen and (max-width: 1200px) {
    .tabsContainer {
        width: 90vw;
        padding: 0 20px;
    }

    .social-tab .v-tab {
        padding: 0 20px !important;
        min-width: 120px;
    }
}

@media only screen and (max-width: 800px) {

    .homeIcon,
    .arrowIcon,
    .nameContainer {
        display: none;
        /* Hide on mobile */
    }

    .tabsContainer {
        width: 100vw !important;
        padding: 0 15px;
    }

    .social-tab .v-tab {
        padding: 0 15px !important;
        font-size: 12px !important;
        min-width: 100px;
    }
}

@media only screen and (max-width: 600px) {
    .social-tab .v-tab {
        padding: 0 10px !important;
        font-size: 11px !important;
        min-width: 80px;
    }
}

/* Arabic language support */
.arabicTabContainer {
    direction: ltr !important;
    transform: rotateY(180deg);
}</style>
  
<style scoped>.tabsContainer {
    border-bottom: 2px solid #fff;
}</style>